/**
 * Get a clean, readable display ID for a ticket.
 * Uses ticketNumber when available (#1, #2, #3...), otherwise falls back
 * to a numeric representation derived from _id for backward compatibility.
 *
 * @param {Object} ticket - Ticket object with ticketNumber and/or _id
 * @returns {string|number} Display ID for the ticket
 */
export const getTicketDisplayId = (ticket) => {
  if (ticket?.ticketNumber != null) return ticket.ticketNumber;
  const id = ticket?._id ?? ticket?.id;
  if (!id) return "—";
  const str = id.toString();
  // Fallback: use last 8 hex chars as decimal for a clean numeric display
  const num = parseInt(str.slice(-8), 16);
  return Number.isNaN(num) ? str.slice(-6) : num;
};
